import React from 'react';
import { FaStar } from 'react-icons/fa';

import cn from '@/lib/clsxm';

import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import { TEXT_TYPE } from '@/components/@base/typography/text/type';
import Props from '@/components/app/product/components/price-info/rate-amount/type';

import localization from '@/constant/localization';

export default function RateAmount({ rate, className }: Props) {
  return (
    <Container center className={cn('flex-col', className)}>
      <Container center className='gap-1'>
        <Text
          type={TEXT_TYPE.SPAN}
          className='productRate text-[22px] font-bold text-[#424244] md:text-[28px]'
        >
          {rate.rateAverage.toFixed(1)}
        </Text>
        <FaStar color='#FEA000' size={13} />
      </Container>

      {rate.rateCount > 0 && (
        <Text type={TEXT_TYPE.SPAN} className='text-sm text-[#76767C]'>
          {localization.outOf} {rate.rateCount} {localization.vote}
        </Text>
      )}
    </Container>
  );
}
